appConfig.getModule()
    .filter('paginationFilter', ['$filter', function ($filter) {
        // from 1 to 10
        return function (arr, from, to, callBack) {
            if (arr) {
                if (callBack) {
                    callBack(arr);
                }
                return arr.slice(from - 1, to);
            } else {
                return arr;
            }
        };
    }])
    .filter('keylength', function () {
        return function (input) {
            if (input) {
                if (!angular.isObject(input)) {
                    throw Error("Usage of non-objects with keylength filter!!")
                }
                return Object.keys(input).length;
            }
            return -1;
        }
    });

